var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar-2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F5C400",
  d: "M60 30C60 13.432 46.569 0 30 0 13.432 0 0 13.432 0 30c0 16.569 13.432 30 30 30 16.569 0 30-13.431 30-30"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#794B37",
  d: "M12.03 44.358c10.452-.92 22.547-1.338 33.037-1.075l2.903 2.37s-.718 2.185-1.54 3.44c-.19.29-.39.59-.683.772-.315.197-.697.24-1.067.277-6.378.64-12.788.945-19.195.915-4.13-.02-8.768-.404-11.468-3.53l-1.982-3.17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#171717",
  d: "M31.13 43.333h-2.258V9.795a.855.855 0 0 1 1.71-.015l.55 33.553z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.96 10.613c-.133-.26-.525-.158-.515.135.325 9.595.295 19.19.652 28.784.013.323.03.67.173.92.182.323.508.383.797.416 4.075.444 8.19.184 12.223-.776-2.45-8.004-3.295-9.454-6.945-17.064l-6.387-12.415z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D73823",
  d: "M41.502 29.665c-.663-1.46-1.433-3.055-2.437-5.14-2.735.09-5.598.098-7.315.095q.045 2.688.092 5.375c2.275.08 6.413-.128 9.657-.33zM31.6 16.475q.06 2.694.105 5.387c1.53.03 3.837-.102 5.91-.257l-2.658-5.165c-1.265.03-2.457.035-3.357.035M44.527 37.658c-.665-2.075-1.223-3.66-1.805-5.126-3.685.236-8.708.238-10.825.228q.06 2.677.15 5.352c2.617.173 8.993-.215 12.478-.455z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.572 20.635c.175-.248.565-.115.55.19-.32 6.773-.295 13.543-.652 20.315-.013.23-.03.477-.175.655-.185.23-.515.273-.81.295a51.5 51.5 0 0 1-11.965-.48.308.308 0 0 1-.218-.457 264 264 0 0 1 10.27-16.268l2.998-4.25z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D73823",
  d: "M21.623 29.3a256 256 0 0 0-2.463 3.832c2.963.173 6.925.355 8.593.228.032-1.332.065-2.668.095-4-1.188.005-3.738.008-6.225-.06M17.835 35.26a254 254 0 0 0-2.293 3.785c2.24.152 10.126.657 12.008.375q.086-1.98.145-3.96c-1.187.008-6.44.035-9.86-.2M27.9 27.27c.035-1.337.072-2.675.122-4.015-.535.003-1.355.005-2.295-.008l-1.152 1.636q-.769 1.125-1.523 2.255c1.84.12 3.795.204 4.85.13z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar-2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})))));
export { SvgAvatar2 as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-2.d0dbca4950bc329f84f7.svg";